// Firebase configuration for client-side usage with multi-tenant support
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Read from runtime config injected by public/config.js
const cfg = (window as any).APP_CONFIG ?? {};

const firebaseConfig = {
  apiKey: cfg.FIREBASE_API_KEY,
  authDomain: cfg.FIREBASE_AUTH_DOMAIN,
  projectId: cfg.FIREBASE_PROJECT_ID,
  storageBucket: cfg.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: cfg.FIREBASE_MESSAGING_SENDER_ID,
  appId: cfg.FIREBASE_APP_ID,
  measurementId: cfg.FIREBASE_MEASUREMENT_ID
};

// Tenant configuration
export const TENANT_CONFIG = {
  NETZOOM: cfg.TENANT_NICKNAME as string,
  MAIN: 'main' // Default main Firebase Auth
};

// Initialize Firebase app with tenant
// This is a local implementation to replace @n20a/libauth's initializeFirebaseAuth
function initializeFirebaseAuth(config: typeof firebaseConfig, tenantId?: string): { app: FirebaseApp; auth: Auth } {
  const app = initializeApp(config);
  const auth = getAuth(app);
  
  if (tenantId) {
    auth.tenantId = tenantId;
  }
  
  return { app, auth };
}

const { app, auth } = initializeFirebaseAuth(firebaseConfig, TENANT_CONFIG.NETZOOM);
const db = getFirestore(app);
// Note: All backend operations migrated to Cloud Run - no Firebase Functions needed

// Configure tenant-aware auth domain for netzoom
export const getTenantAuthDomain = (tenantId: string) => {
  if (tenantId === TENANT_CONFIG.NETZOOM) {
    return `${tenantId}.${firebaseConfig.authDomain}`;
  }
  return firebaseConfig.authDomain;
};

export { app, auth, db, firebaseConfig };
export default app;
